import React, { useEffect, useState } from "react";
import { Button, Checkbox, Input, Select } from "./ui";

import { ApiCalls } from "./apiCalls";

import { floorplannerModes } from "../blueprintSrc/scripts/viewer2d/Viewer2D";
import { objects3DList } from "../blueprintSrc/scripts/viewer2d/objects3D";
import { Configuration, directionalDrag, dragOnlyX, dragOnlyY, snapToGrid, gridSpacing } from "../blueprintSrc/scripts/core/configuration";

function buildOrgList(orgAPIResponse){

    let orgList = [{
        label: 'Select Organization',
        value: 0
    }]

    for (let index = 0; index < orgAPIResponse.length; index++) {
        
        orgList.push(
            {
                label: orgAPIResponse[index]['meta']['name'],
                value: orgAPIResponse[index]['_id']
            }
        )
    }
    return orgList
}

function buildProjectList(projectAPIResponse){

    let projectList = [
        {
            label: 'Select Project',
            value: 0
        }
    ]

    for (let index = 0; index < projectAPIResponse.length; index++) {
        
        projectList.push(
            {
                label: projectAPIResponse[index]['meta']['name'],
                value: projectAPIResponse[index]['_id']
            }
        )
    }
    return projectList
}

const Sidebar = (props) => {
    let objectKeys = Object.keys(objects3DList);

    let tmpList = [];
    for (let i = 0; i < objectKeys.length; ++i) {
        tmpList.push({ label: objectKeys[i], value: objectKeys[i] });
    }

    // const [mode, setMode] = useState(props.floorplanner.__mode);

    const [objectList] = useState(tmpList);
    const [selectedItem, setSelectedItem] = useState(objectKeys[0]);
    const [apiCaller] = useState(new ApiCalls());
    const [orgListSelect, setOrgListSelect] = useState([{label: 'Select Organization',value: 0}]);
    const [projectListSelect, setProjectListSelect] = useState([{label: 'Select Project',value: 0}]);
    const [projectListSelectState, setProjectListSelectState] = useState(true);
    const [orgId, setOrgId] = useState(0);
    const [projectId, setProjectId] = useState(0);
    
    const gridValues = [10, 20, 50, 100];
    const getGridIndex = (value) => {
        const closestValue = gridValues.reduce((prev, curr) => 
            Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
        );
        return gridValues.indexOf(closestValue);
    };
    const [gridSpacingIndex, setGridSpacingIndex] = useState(
        getGridIndex(Configuration.getNumericValue(gridSpacing))
    );
    

    useEffect(async () => {

        const orgList = await apiCaller.getOrgList();
        console.log(orgList);
        const formatedOrgList = buildOrgList(orgList);
        setOrgListSelect(formatedOrgList);
        

    }, [apiCaller]);

    

    //Style of the sidebar (TODO: maybe change the size? or make it dinamic?)
    const sidebarStyle = {
        height: '100%', /* Full-height: remove this if you want "auto" height */
        width: '205px', /* Set the width of the sidebar */
        position: 'fixed', /* Fixed Sidebar (stay in place on scroll) */
        zIndex: 1, /* Stay on top */
        top: 0, /* Stay at the top */
        left: 0,
        backgroundColor: '#ffffff', /* light gray */
        overflowX: 'hidden', /* Disable horizontal scroll */
        paddingTop: '10px',
        paddingBottom: '10px',
        borderRight: '2px solid #e0e0e0',
        scrollY : 'scroll',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: '',
    }

    const handleSelectChange = (evt) => {
        setSelectedItem(evt.target.value);
    }

    const handleOrgSelectChange = async (evt) => {

        console.log("org changed evt"+evt);
        console.log("org changed value"+evt.target.value);
        setOrgId(evt.target.value);

        if(evt.target.value == 0 || evt.target.value == undefined || evt.target.value == null || evt.target.value == "0"){
            console.log("org changed value 0");
            setProjectListSelect([{label: 'Select Project',value: 0}]);
            return;
        }

        setProjectListSelect([{label: 'Loading ...',value: 0}]);
        const projects = await apiCaller.getProjectsList(evt.target.value);
        const formatedProjectList = buildProjectList(projects);
        setProjectListSelect(formatedProjectList);
        setProjectListSelectState(false);

    }

    const handleProjectSelectChange = (evt) => {
        setProjectId(evt.target.value);
    }

    const buttonSize = {width: "180px", margin: "5px"};
    const chkbox = {width: "160px", margin: "5px", alignSelf: 'flex-start'};

    // console.log(props);

    return (
        
        <div className="sideBar" style={sidebarStyle}>
           
            <Button style={{...buttonSize, color: 'lightgray'}} color='black' onClick={props.switchViewer}>Switch 2D / 3D</Button>

            {/*
            <Button style={buttonSize} color='blue' onClick={() => {
                var input = document.createElement('input');
                input.type = 'file';
                input.accept = ".blueprint3d"

                input.onchange = e => {
                    let file = e.target.files[0];
                    props.loadBlueprint3DDesign(file);
                }

                input.click();
            }}>Load Design</Button>
            <Button style={buttonSize} style={buttonSize} color='blue' onClick={props.saveBlueprint3DDesign}>Save Design</Button>
            <Button style={buttonSize} color='blue' onClick={() => { props.saveAllFloorsAsGlb() }}>Export all floors</Button>
            <Button style={buttonSize} color='blue' onClick={() => { props.saveBlueprint3D(false) }}>Export .glb</Button>
            <Button style={buttonSize} color='blue' onClick={() => { props.saveAllFloorsAsGlb(true) }}>Send all floors to HEGIAS</Button>
            */}
            
            <Button style={{...buttonSize, marginBottom: '40px'}} color='red' onClick={props.reset}>Reset Floorplan</Button>
            
            {/*
            <Button style={buttonSize} color='lightGreen' onClick={() => { props.switchToTransform(); props.hideWindowSettings() }}>Transform mode</Button>
            <Text style={{...buttonSize, marginBottom: '20px'}}>{props.floorplannerMode}</Text>
            */}
            <Button style={{...buttonSize}} color={props.floorplannerMode===floorplannerModes.MOVE ? 'lightGreen' : 'black'} onClick={props.switchToMove}>Move Mode</Button>
            <Button style={{...buttonSize}} color={props.floorplannerMode===floorplannerModes.DRAW ? 'lightGreen' : 'black'} onClick={() => { props.switchToDraw(); props.hideWindowSettings() }}>Draw Mode</Button>
            <Button style={{...buttonSize}} color={props.floorplannerMode===floorplannerModes.DOORADD ? 'lightGreen' : 'black'} onClick={() => { props.switchToDoorAdd(); props.hideWindowSettings() }}>Add Doors</Button>
            <Button style={{...buttonSize, marginBottom: '20px'}} color={props.floorplannerMode===floorplannerModes.WINDOWADD ? 'lightGreen' : 'black'} onClick={props.switchToWindowAdd}>Add Windows</Button>
            
            {/*
            <Select options={objectList}  onChange={handleSelectChange} />
            <Button style={buttonSize} color='lightGreen' onClick={() => { props.switchToItemAdd({ value: selectedItem }); props.hideWindowSettings() }}>Add item</Button>
            */}
            {/*
            <Checkbox style={chkbox} label='Drag only x' defaultChecked={Configuration.getBooleanValue(dragOnlyX)} onChange={(ev) => { props.setDragOnlyX(ev.target.checked) }} />
            <Checkbox style={chkbox} label='Drag only y' defaultChecked={Configuration.getBooleanValue(dragOnlyY)} onChange={(ev) => { props.setDragOnlyY(ev.target.checked) }} />
            */}



            <Checkbox style={chkbox} label={`Snap to grid (${gridValues[gridSpacingIndex]}cm)`} defaultChecked={Configuration.getBooleanValue(snapToGrid)} onChange={(ev) => { props.setSnapToGrid(ev.target.checked) }} />
            
            <div style={{ width: '100%', padding: '10px 20px', paddingTop: '0px' }}>
                {/* <label style={{ fontSize: '12px', marginBottom: '8px', display: 'block' }}>
                    Grid spacing: {gridValues[gridSpacingIndex]} cm
                </label> */}
                <input 
                    type="range" 
                    min="0" 
                    max="3" 
                    step="1"
                    value={gridSpacingIndex}
                    onChange={(evt) => {
                        const newIndex = parseInt(evt.target.value);
                        setGridSpacingIndex(newIndex);
                        props.setGridSpacing(gridValues[newIndex]);
                    }}
                    style={{ width: '140px', cursor: 'pointer', marginLeft: '20px', marginRight: '15px' }}
                />
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', marginTop: '1px', marginLeft: '24px', marginRight: '7px' }}>
                    <span>10</span>
                    <span>20</span>
                    <span>50</span>
                    <span>100</span>
                </div> */}
            </div>

            <Checkbox style={chkbox} label='Directional drag' defaultChecked={Configuration.getBooleanValue(directionalDrag)} onChange={(ev) => { props.setDirectionalDrag(ev.target.checked) }} />
            

            <div style={{flex: 1}}></div>

            
            <span style={{...buttonSize, display: 'grid', marginTop: '60px'}}>
                <Select options={orgListSelect} onChange={handleOrgSelectChange}/>
            </span>
            <span style={{...buttonSize, display: 'grid'}}>
                <Select options={projectListSelect} onChange={handleProjectSelectChange} isDisabled={projectListSelectState}/>
            </span>
            

            <Button style={{...buttonSize, marginBottom: '20px'}} color='blue' onClick={() => { props.saveBlueprint3DNew(true,orgId,projectId) }}>Import to HEGIAS...</Button>



            <Button style={{...buttonSize, marginTop: '20px'}} color='orange' onClick={() => props.logOut()}>Log out</Button>

        </div>
    )

}

export default Sidebar;